module.exports = __webpack_public_path__ + "assets/img/purchase_login.9c42a0c0.png";